import { render, staticRenderFns } from "./RegisterTemplatePRP.vue?vue&type=template&id=5b40ee2c&scoped=true&"
import script from "./RegisterTemplatePRP.vue?vue&type=script&lang=js&"
export * from "./RegisterTemplatePRP.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTemplatePRP.vue?vue&type=style&index=0&id=5b40ee2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40ee2c",
  null
  
)

export default component.exports